var _style, _path, _g, _g2, _path2, _path3, _path4, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDdpiBanner3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Elements",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1300 850",
    style: {
      enableBackground: "new 0 0 1300 850"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000072268336192239828770000018262830393975504284_);}\r\n\t.st2{fill:#D7695F;}\r\n\t.st3{fill:url(#SVGID_00000118366390033350934040000003534186635156329862_);}\r\n\t.st4{fill:url(#SVGID_00000052820656742587737920000006594318996672047488_);}\r\n\t.st5{fill:#F7F8F9;}\r\n\t.st6{fill:#FFFFFF;}\r\n\t.st7{fill:#1A425B;}\r\n\t.st8{fill:#0A78A3;}\r\n\t.st9{fill:#E6E6FC;}\r\n\t.st10{fill:#D3D3ED;}\r\n\t.st11{fill:#EFEFEF;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 881.7648,
    y1: -748.4804,
    x2: 459.1653,
    y2: -1117.5312,
    gradientTransform: "matrix(1 0 0 1 0 1316)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DB6730",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09394195,
    style: {
      stopColor: "#D75F34",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6999,
    style: {
      stopColor: "#BE2E4F",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B51B59",
      stopOpacity: 0.4
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.7,146.1c31-42,106.3-62.2,237.3,11.6s255.1-28.9,355.5-28.9c173.9,0,373.3,211.3,91.3,432.8 c-282,221.4-394.3,182.2-520.5,92.6C245.9,529.7,180.1,251.1,257.7,146.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134950738468339900900000017569889361488371348_",
    gradientUnits: "userSpaceOnUse",
    x1: 311.6199,
    y1: -1061.6857,
    x2: 813.8578,
    y2: -717.2112,
    gradientTransform: "matrix(1 0 0 1 0 1316)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DB6730",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09394221,
    style: {
      stopColor: "#D75F34",
      stopOpacity: 0.6376
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6999,
    style: {
      stopColor: "#BE2E4F",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B51B59",
      stopOpacity: 0.6
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134950738468339900900000017569889361488371348_)"
    },
    d: "M210.7,522.4 C165.9,357.4,467,33.2,639.9,104.2S807,329.9,946,413.4c151.9,91.3,74.9,233.6,6.8,259.6c-210.1,80.3-397.3-85.4-503.8-50.7 C342.4,657.1,240,630.2,210.7,522.4z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M146.4,329.8c-6.8,0-12.3-5.5-12.3-12.3s5.5-12.3,12.3-12.3s12.3,5.5,12.3,12.3 C158.8,324.3,153.2,329.8,146.4,329.8z M146.4,309.6c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S150.8,309.6,146.4,309.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M146.4,358.7c-1.2,0-2.2-1-2.2-2.2v-15.4c0-1.2,1-2.2,2.2-2.2s2.2,1,2.2,2.2v15.4 C148.6,357.7,147.6,358.7,146.4,358.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M146.4,296.1c-1.2,0-2.2-1-2.2-2.2v-15.4c0-1.2,1-2.2,2.2-2.2s2.2,1,2.2,2.2V294 C148.6,295.2,147.6,296.1,146.4,296.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.9,319.7h-15.4c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h15.4c1.2,0,2.2,1,2.2,2.2S124.1,319.7,122.9,319.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M185.4,319.7H170c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h15.4c1.2,0,2.2,1,2.2,2.2 C187.6,318.7,186.6,319.7,185.4,319.7z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1120.7,472.4c-6.8,0-12.3-5.5-12.3-12.3s5.5-12.3,12.3-12.3s12.3,5.5,12.3,12.3 C1133,466.8,1127.5,472.4,1120.7,472.4z M1120.7,452.1c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S1125.1,452.1,1120.7,452.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1120.7,501.2c-1.2,0-2.2-1-2.2-2.2v-15.4c0-1.2,1-2.2,2.2-2.2s2.2,1,2.2,2.2V499 C1122.9,500.2,1121.9,501.2,1120.7,501.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1120.7,438.7c-1.2,0-2.2-1-2.2-2.2v-15.4c0-1.2,1-2.2,2.2-2.2s2.2,1,2.2,2.2v15.4 C1122.9,437.7,1121.9,438.7,1120.7,438.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1097.1,462.2h-15.4c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h15.4c1.2,0,2.2,1,2.2,2.2 C1099.3,461.3,1098.3,462.2,1097.1,462.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1159.7,462.2h-15.4c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h15.4c1.2,0,2.2,1,2.2,2.2 C1161.8,461.3,1160.9,462.2,1159.7,462.2z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.9,506.5c-8.4,0-15.1-6.8-15.1-15.1c0-8.4,6.8-15.1,15.1-15.1c8.4,0,15.1,6.8,15.1,15.1 S72.2,506.5,63.9,506.5z M63.9,480.5c-6,0-10.8,4.8-10.8,10.8s4.8,10.8,10.8,10.8s10.8-4.8,10.8-10.8 C74.7,485.4,69.8,480.5,63.9,480.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1046.9,156.3c-8.4,0-15.1-6.8-15.1-15.1s6.8-15.1,15.1-15.1c8.3,0,15.1,6.8,15.1,15.1 S1055.2,156.3,1046.9,156.3z M1046.9,130.3c-6,0-10.8,4.8-10.8,10.8s4.8,10.8,10.8,10.8s10.8-4.8,10.8-10.8 C1057.7,135.2,1052.8,130.3,1046.9,130.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.7,184.4c-8.4,0-15.1-6.8-15.1-15.1c0-8.4,6.8-15.1,15.1-15.1c8.4,0,15.1,6.8,15.1,15.1 C192.9,177.6,186.1,184.4,177.7,184.4z M177.7,158.4c-6,0-10.8,4.8-10.8,10.8s4.8,10.8,10.8,10.8s10.8-4.8,10.8-10.8 C188.5,163.3,183.7,158.4,177.7,158.4z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45,377.3c-1.2,0-2.2-1-2.2-2.2v-26.4c0-1.2,1-2.2,2.2-2.2s2.2,1,2.2,2.2v26.4 C47.2,376.3,46.2,377.3,45,377.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.2,364.1H31.8c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h26.4c1.2,0,2.2,1,2.2,2.2 C60.4,363.2,59.4,364.1,58.2,364.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M764.5,740.7c-1.2,0-2.2-1-2.2-2.2v-26.4c0-1.2,1-2.2,2.2-2.2s2.2,1,2.2,2.2v26.4 C766.7,739.7,765.7,740.7,764.5,740.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M777.7,727.5h-26.4c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h26.4c1.2,0,2.2,1,2.2,2.2 C779.9,726.6,778.9,727.5,777.7,727.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1152,280.8c-1.2,0-2.2-1-2.2-2.2v-26.4c0-1.2,1-2.2,2.2-2.2s2.2,1,2.2,2.2v26.4 C1154.1,279.8,1153.2,280.8,1152,280.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1165.2,267.6h-26.4c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h26.4c1.2,0,2.2,1,2.2,2.2 C1167.3,266.6,1166.4,267.6,1165.2,267.6z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1255,390.5c-1.2,0-2.2-1-2.2-2.2V362c0-1.2,1-2.2,2.2-2.2s2.2,1,2.2,2.2v26.4 C1257.2,389.5,1256.2,390.5,1255,390.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1268.2,377.3h-26.4c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h26.4c1.2,0,2.2,1,2.2,2.2 C1270.4,376.3,1269.4,377.3,1268.2,377.3z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021830278939765818060000014453842755091462024_",
    gradientUnits: "userSpaceOnUse",
    x1: 660.1609,
    y1: -1225.8788,
    x2: 655.8186,
    y2: -1079.6941,
    gradientTransform: "matrix(1 0 0 1 0 1316)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EED970"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    style: {
      stopColor: "#E5AD69",
      stopOpacity: 0.647
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7854,
    style: {
      stopColor: "#DB7C62",
      stopOpacity: 0.2146
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7695F",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021830278939765818060000014453842755091462024_)"
    },
    d: "M262.7,179.1 c31-42,106.3-62.2,237.3,11.6s255.1-28.9,355.5-28.9c97.4,0,202.7,66.2,227.1,163.4c-6.2-114.9-124-196.4-232-196.4 c-100.4,0-224.5,102.8-355.5,28.9c-131-73.8-206.2-53.6-237.3-11.6c-32.3,43.7-39.8,117.6-24.7,198 C225.5,276.9,234.8,216.8,262.7,179.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170976589733389420820000003518506923472276155_",
    gradientUnits: "userSpaceOnUse",
    x1: 1062,
    y1: -701.2,
    x2: 1154.2,
    y2: -701.2,
    gradientTransform: "matrix(1 0 0 1 0 1316)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DB6730",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04078131,
    style: {
      stopColor: "#DB6732",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5446,
    style: {
      stopColor: "#D9684C",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7695F",
      stopOpacity: 0.6
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000170976589733389420820000003518506923472276155_)"
    },
    cx: 1108.1,
    cy: 614.8,
    r: 46.1
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M394,322.1c15.2-2.7,31.7-3.8,48.7-3.8c25.6,0,46.3,5,61.4,16.4c15.7,12.1,25.1,29.4,25.1,55.8 c0,33.6-14.3,61-34.9,76.8c-19.8,15.3-44.5,22.1-83,22.1c-22.6,0-41.2-2-48.6-3.7L394,322.1z M411.9,454.1 c2.8,0.4,6.8,0.8,13.2,0.8c16.4,0,32.8-6.5,42.5-18.4c9.8-12,15.1-27.2,15.1-45.9c0-25.4-14.8-38.3-39.3-38.3 c-5.7,0-9.3,0.4-12,0.9L411.9,454.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M568.4,322.1c15.2-2.7,31.7-3.8,48.7-3.8c25.6,0,46.3,5,61.4,16.4c15.7,12.1,25.1,29.4,25.1,55.8 c0,33.6-14.3,61-34.9,76.8c-19.8,15.3-44.5,22.1-83,22.1c-22.6,0-41.2-2-48.6-3.7L568.4,322.1z M586.3,454.1 c2.8,0.4,6.8,0.8,13.2,0.8c16.4,0,32.8-6.5,42.5-18.4c9.8-12,15.1-27.2,15.1-45.9c0-25.4-14.8-38.3-39.3-38.3 c-5.7,0-9.3,0.4-12,0.9L586.3,454.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M742.4,322.8c11.5-2.9,29.8-4.6,47.2-4.6c14.7,0,32.9,1.8,46.3,10.3c13,7.8,20.9,20.7,20.9,38.3 c0,22.2-9.9,38.4-24,48.9c-14.1,10.7-34,15.5-55.3,15.5c-5.8,0-10.7-0.8-13.7-0.9l-11.1,57.9H711L742.4,322.8z M770.3,395.7 c3,0.6,6.6,1.1,12.7,1.1c18.7,0,30.9-12.3,30.9-26.2c0-14.5-10.6-18.6-22.2-18.6c-6.1,0-10.5,0.4-13.2,0.9L770.3,395.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M930.4,319.4l-32,168.9h-42.7l32-168.9H930.4z"
  })))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M988.7,714.7H629.6c-2.2,0-4-1.8-4-4V538.2c0-2.2,1.8-4,4-4h359.1c2.2,0,4,1.8,4,4v172.5 C992.7,712.9,990.9,714.7,988.7,714.7z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M925,628.3h40.2c0,22.1-18.2,40.2-40.2,40.2c-22.1,0-40.2-18.2-40.2-40.2c0-22.1,18.2-40.2,40.2-40.2 c0.7,0,1.3,0,2,0L925,628.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M930.8,622.8l2.6-40.2c10.1,0.7,19.5,5.1,26.5,12.4c7,7.3,10.9,16.9,11.1,27L930.8,622.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M861.6,590.1H726.9c-1.3,0-2.3-1-2.3-2.3l0,0c0-1.3,1-2.3,2.3-2.3h134.7c1.3,0,2.3,1,2.3,2.3l0,0 C863.9,589.1,862.9,590.1,861.6,590.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M861.6,569.4H726.9c-1.3,0-2.3-1-2.3-2.3l0,0c0-1.3,1-2.3,2.3-2.3h134.7c1.3,0,2.3,1,2.3,2.3l0,0 C863.9,568.4,862.9,569.4,861.6,569.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M861.6,652.4H652.3c-1.3,0-2.3-1-2.3-2.3l0,0c0-1.3,1-2.3,2.3-2.3h209.3c1.3,0,2.3,1,2.3,2.3l0,0 C863.9,651.4,862.9,652.4,861.6,652.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M861.6,631.6H652.3c-1.3,0-2.3-1-2.3-2.3l0,0c0-1.3,1-2.3,2.3-2.3h209.3c1.3,0,2.3,1,2.3,2.3l0,0 C863.9,630.6,862.9,631.6,861.6,631.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M861.6,610.9H726.9c-1.3,0-2.3-1-2.3-2.3l0,0c0-1.3,1-2.3,2.3-2.3h134.7c1.3,0,2.3,1,2.3,2.3l0,0 C863.9,609.9,862.9,610.9,861.6,610.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M861.6,693.9H652.3c-1.3,0-2.3-1-2.3-2.3l0,0c0-1.3,1-2.3,2.3-2.3h209.3c1.3,0,2.3,1,2.3,2.3l0,0 C863.9,692.9,862.9,693.9,861.6,693.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M861.6,673.1H652.3c-1.3,0-2.3-1-2.3-2.3l0,0c0-1.3,1-2.3,2.3-2.3h209.3c1.3,0,2.3,1,2.3,2.3l0,0 C863.9,672.1,862.9,673.1,861.6,673.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 679.6,
    cy: 576,
    r: 15.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M706.6,610.8c-1.5-9.8-10-17.3-20.3-17.3h-13.6c-10.2,0-18.7,7.5-20.3,17.3H706.6z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M384.1,276.7c1.6,1,3.9,1.7,6.4,1.7c2.2,0,4.3-1,4.3-3.1c0-1.5-1.2-2.5-3.6-3.8c-2.9-1.5-5.6-3.6-5.6-7.1 c0-5.5,4.8-8.8,10.6-8.8c3.3,0,5.2,0.7,6.4,1.3l-1.8,4.8c-0.9-0.5-2.8-1.2-5-1.2c-2.7,0-4.1,1.3-4.1,2.8c0,1.6,1.7,2.5,3.9,3.8 c3.3,1.7,5.3,3.9,5.3,7.1c0,6-5,9.1-11,9.1c-3.7,0-6.4-1-7.7-1.9L384.1,276.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M419.5,281.9c-2.3,1.1-5.1,1.5-7.3,1.5c-5.6,0-8.5-3.2-8.5-8.3c0-5.9,4.3-12.2,11.4-12.2 c4,0,6.8,2.2,6.8,5.9c0,5-4.9,6.8-12.7,6.6c0,0.6,0.2,1.4,0.6,2c0.8,1,2.1,1.5,3.7,1.5c2.1,0,3.9-0.5,5.5-1.2L419.5,281.9z  M414.4,267.2c-2.7,0-4.2,2.2-4.6,4c4.5,0,6.7-0.6,6.7-2.4C416.5,267.9,415.7,267.2,414.4,267.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M423.2,283l5.4-28.4h5.8L429,283H423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M433.8,283l5.4-28.4h5.8l-5.4,28.4H433.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M457.1,256h15.8l-1,4.9h-10l-1.2,6.3h9.4l-0.9,4.9h-9.4l-2,10.9H452L457.1,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M485,283c0-1.1,0.2-2.5,0.3-3.9h-0.1c-1.8,3.3-4.3,4.3-6.6,4.3c-3.5,0-5.9-2.7-5.9-6.8 c0-6.6,4.4-13.6,14-13.6c2.3,0,4.8,0.5,6.5,1l-2.1,10.2c-0.5,2.5-0.9,6.4-0.8,8.8H485z M486.6,267.5c-0.4-0.1-1-0.2-1.6-0.2 c-3.7,0-6.4,4.6-6.4,8.2c0,1.9,0.8,3.2,2.4,3.2c1.7,0,3.9-2,4.7-6.8L486.6,267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M495.1,277.8c1.1,0.6,3.2,1.4,5.1,1.4c1.6,0,2.5-0.8,2.5-1.8s-0.6-1.6-2.4-2.5c-2.3-1.1-4.1-2.8-4.1-5.2 c0-4.1,3.6-6.7,8.6-6.7c2.3,0,4.1,0.5,5,1l-1.4,4.1c-0.8-0.4-2.2-0.9-3.9-0.9c-1.5,0-2.5,0.7-2.5,1.7c0,0.8,0.8,1.5,2.4,2.2 c2.1,1.1,4.4,2.6,4.4,5.3c0,4.5-3.8,6.9-9,6.9c-2.5,0-4.8-0.7-6-1.5L495.1,277.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M522,257.9l-1,5.5h4.2l-0.9,4.4h-4.2l-1.3,6.6c-0.2,0.8-0.3,1.8-0.3,2.5c0,1,0.4,1.6,1.7,1.6 c0.5,0,1.1,0,1.6-0.1l-0.7,4.5c-0.8,0.3-2.2,0.4-3.4,0.4c-3.5,0-5.1-1.8-5.1-4.2c0-1.1,0.1-2.1,0.4-3.6l1.5-7.8H512l0.8-4.4h2.5 l0.8-4.1L522,257.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M541.3,281.9c-2.3,1.1-5.1,1.5-7.3,1.5c-5.6,0-8.5-3.2-8.5-8.3c0-5.9,4.3-12.2,11.4-12.2 c4,0,6.8,2.2,6.8,5.9c0,5-4.9,6.8-12.7,6.6c0,0.6,0.2,1.4,0.6,2c0.8,1,2.1,1.5,3.7,1.5c2.1,0,3.9-0.5,5.5-1.2L541.3,281.9z  M536.2,267.2c-2.7,0-4.2,2.2-4.6,4c4.5,0,6.7-0.6,6.7-2.4C538.3,267.9,537.5,267.2,536.2,267.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M544.9,283l2.2-11.7c0.5-2.9,0.8-6.2,1-7.9h5c-0.1,1.3-0.2,2.6-0.4,4h0.1c1.4-2.6,3.6-4.5,6.2-4.5 c0.4,0,0.7,0,1.1,0l-1.1,5.6c-0.3,0-0.6,0-0.9,0c-3.7,0-5.4,3.3-6.1,7.1l-1.4,7.3h-5.7L544.9,283L544.9,283z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M574.5,263.4v8.3c0,2.2,0,4.1-0.2,6.2h0.1c0.7-2.1,1.5-4,2.4-6l3.9-8.5h4.7l0.5,8.3c0.1,2.3,0.2,4.2,0.1,6.3 h0.1c0.6-2.2,1.3-4.1,2.2-6.4l3.3-8.2h5.8l-9.5,19.6h-5.4l-0.6-6.8c-0.1-2-0.2-3.9-0.2-6.3h-0.1c-1,2.8-1.5,4.2-2.3,6L576,283 h-5.4l-1.8-19.6H574.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M596.4,283l3.7-19.6h5.8l-3.7,19.6H596.4z M601,258.2c0-1.9,1.5-3.3,3.3-3.3c1.7,0,2.9,1.1,2.9,2.8 c0,2-1.6,3.2-3.4,3.2C602.2,261,601,259.9,601,258.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M618.1,257.9l-1,5.5h4.2l-0.9,4.4h-4.2l-1.3,6.6c-0.2,0.8-0.3,1.8-0.3,2.5c0,1,0.4,1.6,1.7,1.6 c0.5,0,1.1,0,1.6-0.1l-0.7,4.5c-0.8,0.3-2.2,0.4-3.4,0.4c-3.5,0-5.1-1.8-5.1-4.2c0-1.1,0.1-2.1,0.4-3.6l1.5-7.8h-2.5l0.8-4.4h2.5 l0.8-4.1L618.1,257.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M621,283l5.4-28.4h5.8l-2.2,11.3h0.1c1.6-1.8,3.7-3,6.2-3c3.1,0,4.9,1.9,4.9,5.3c0,0.9-0.2,2.4-0.4,3.5 l-2.1,11.2h-5.8l2-10.7c0.1-0.8,0.2-1.6,0.2-2.4c0-1.3-0.5-2.2-2-2.2c-2,0-4.1,2.5-4.8,6.4l-1.7,9L621,283L621,283z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdpiBanner3);
export default __webpack_public_path__ + "static/media/ddpi-banner3.c2d79cc368e92dbe54ba6d6702783ae5.svg";
export { ForwardRef as ReactComponent };